export default __webpack_public_path__ + "static/broadcastImg5-7513fa07b86dad6e7e54f440855790e8.webp";